import { render, staticRenderFns } from "./DelOrgItem.vue?vue&type=template&id=bf406dea&scoped=true"
import script from "./DelOrgItem.vue?vue&type=script&lang=js"
export * from "./DelOrgItem.vue?vue&type=script&lang=js"
import style0 from "./DelOrgItem.vue?vue&type=style&index=0&id=bf406dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf406dea",
  null
  
)

export default component.exports